export const ProductEndpoints = {
  sale: (membershipSlug: string) => `/rest/public/v2/products/${membershipSlug}/sale`,
  progress: (membershipSlug: string) => `/rest/v1/products/${membershipSlug}/progress`,
  purchased: (membershipSlug: string) => `/rest/v3/products/${membershipSlug}/purchased`,
  getUserRoleByProduct: (membershipSlug: string, productId: string) =>
    `/rest/v1/memberships/${membershipSlug}/products/${productId}/users/me/role`,
  getProductsWithModules: (membershipSlug: string) =>
    `/rest/public/v1/products/${membershipSlug}/with-module`,
  getMembershipInfoByProductId: (productId: string) => `/rest/v2/memberships/products/${productId}`,
  getDefault: (membershipId: string) =>
    `/rest/public/v1/memberships/${membershipId}/default-product`
}
